import { Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

import facilities from "../../../constants/facilities_detail.json";
import { BTypeCardView } from "../CardView";
import { ColorSystemProps } from "../../../constants";
import { ClickEventType } from "../../../types";

interface CTypeFacilityListProps {
  title: string;
  sido?: string;
  sigungu?: string;
  defaultHref: string;
  mainColor: ColorSystemProps;
  event: ClickEventType;
}

export function CTypeFacilityList({
  title,
  sido,
  sigungu,
  defaultHref,
  mainColor,
  event,
}: CTypeFacilityListProps) {
  const facilityCardItems = sigungu
    ? facilities.filter((p) => String(p.sigungu) === String(sigungu))
    : facilities.filter((p) => String(p.sido) === String(sido));

  const [prices, setPrices] = useState([] as { min: number; max: number }[]);

  useEffect(() => {
    const facilityCardPrices = facilityCardItems.map(({ hallrents }, index) => {
      const facilityCardPrice = hallrents.reduce(
        (acc, { charge }) => {
          const { min, max } = acc;
          const newAcc = { ...acc };

          if (charge) {
            if (charge < min) {
              newAcc.min = charge;
            }

            if (charge > max) {
              newAcc.max = charge;
            }
            return newAcc;
          }

          return newAcc;
        },
        {
          min: 0,
          max: 0,
        } as Record<"min" | "max", number>
      );

      return facilityCardPrice;
    });

    setPrices(facilityCardPrices);
  }, []);

  return (
    <Stack
      margin="20px 12px"
      padding="16px"
      style={{
        background: "white",
        boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
      }}
    >
      <Box component="h3" mb="4px" className="subtitle_18_sb">
        {title}
      </Box>
      <Box marginTop="6px" />
      <Stack component="ul" gap="16px">
        {prices.length > 0 &&
          facilityCardItems?.map((res, index) => {
            const price = prices[index];
            const { max, min } = price;
            const averagePrice = (max + min) / 2;

            return (
              <BTypeCardView
                mainColor={mainColor}
                key={res.companyname}
                name={res.companyname}
                href={`${defaultHref}/${res.id}/`}
                arrowText={"상세 비용 알아보기"}
                descriptions={[
                  `평균 가격: ${Math.round(averagePrice).toLocaleString()}원`,
                ]}
                imgSrc={res.images?.[0].url || ""}
                hasOneDayBasis={false}
                event={event}
              />
            );
          })}
      </Stack>
    </Stack>
  );
}
